import { fixString } from "@monta/router-react";

export const sendToExam = (data: any) => {
  if (data.inExam) {
    const examTakingId = data.examTakingId;
    if (data.isExamSingleQuestion) {
      const url = fixString(
        `/#!examSingleQuestion;refID=${examTakingId}`,
        "EXAM_URL",
      );
      if (url) window.location.href = url;
    } else {
      const url = fixString(
        `/#!takeexam;refID=${examTakingId};examSerialNo=1;bookletType=1`,
        "EXAM_URL",
      );
      if (url) window.location.href = url;
    }
  }
};
